import { FormNames } from "./CESTypes";

const registrationSubSteps = [
  {
    substep: 1,
    fieldNames: ["addressCity", "birthdate", "termsAndConditions", "marketingConsentRegistration"]
  },
  {
    substep: 2,
    fieldNames: ["communicationOptins_dahadaha_email", "communicationOptins_dahadaha_sms", "communicationOptins_dahadaha_phone", "captcha"]
  },
];

export interface StepDescriptor {
  form: string;
  step: number;
  substep?: number;
  totalSteps: number;
}

export const steppedFormFlows: Record<string, StepDescriptor[]> = {
  mobileOtp: [
    { form: FormNames.ValidateEmailForm, step: 1, totalSteps: 3 },
    { form: FormNames.Registration, step: 2, substep: 1, totalSteps: 3 },
    { form: FormNames.Registration, step: 3, substep: 2, totalSteps: 3 },
  ],
  socialRegistration: [
    { form: FormNames.Registration, step: 1, substep: 1, totalSteps: 4 },
    { form: FormNames.Registration, step: 2, substep: 2, totalSteps: 4 },
    { form: FormNames.GenerateOtpForm, step: 3, totalSteps: 4 },
    { form: FormNames.ValidateOtpForm, step: 4, totalSteps: 4 },
  ],
};


export const getRegistrationFormSubStep = (substep: number) => (registrationSubSteps.find(item => item.substep === substep));